<div class="LayerTree">
    <DataLayerTree :data.sync="rootNode" :map="map" :treeDef="treeDef" :layerDef="layerDef" />
    <Tree :rootNode="rootNode" :showFilterInput="showFilterInput" />
</div>
